import { openFriendsPanel } from './FriendsPanel.js';
import { attachSocialNotifications } from './socialNotifications.js';
import { showToast } from './Toast.js';
import { gameState } from '../state/gameState.js';
import { hasNewGifts } from '../farm/fuelGifts.mjs';
import { gameButton } from './gameUi.js';
import { pinToCamera } from './pin.mjs';
import { installPanelSwitch, switchButton } from './panelSwitch.js';

// Top-left "Znajomi {friends}" wooden button + social toast/badge wiring. Shown on every gameplay
// screen (your house, garden, yard, town, …) EXCEPT the shop interiors. Pinned
// (scrollFactor 0) so it stays put in scrolling scenes; the notification listeners
// auto-detach on scene shutdown (see attachSocialNotifications).
export function attachFriendsButton(scene) {
  const W = 190, H = 44;
  const open = () => openFriendsPanel(scene, {
    onVisit: (hostId, hostName) => scene.scene.start('VisitMainScene', { hostId, hostName }),
  });
  let click = open;
  const btn = gameButton(scene, 20 + W / 2, 20 + H / 2, W, H, 'Znajomi {friends}', () => click(), { variant: 'wood', fontSize: 20 });
  // Tap away from any window closes it; this button with a window open switches to Znajomi (panelSwitch.js).
  installPanelSwitch(scene);
  click = switchButton(scene, btn, 'friends', open).onClick;
  // Children pinned too: a container child hit-tests with its own scroll factor (pin.mjs).
  pinToCamera(btn).setDepth(100);
  let badge = 0;
  // A friend request adds a count; friends' canisters waiting to be seen add a red dot.
  let label = '';
  const paint = () => {
    const s = `Znajomi {friends}${badge > 0 ? ` (${badge})` : ''}${hasNewGifts(gameState.raw) ? ' {dot_red}' : ''}`;
    if (s !== label) { label = s; btn.setLabel(s); }
  };
  attachSocialNotifications(scene, {
    onToast: (t) => showToast(scene, t),
    onBadge: (d) => { badge += d; paint(); },
  });
  const off = gameState.on(paint);
  scene.events.once('shutdown', () => off?.());
  paint();
  return btn;
}
